// --------------------------------------------------------------------------------
// NOTE: This file was automatically generated, do not modify manually.
// --------------------------------------------------------------------------------
import { Measure } from './Measure';
import { Volume } from './Volume';
import { VolumePrism } from './VolumePrism';
import { PrismRange } from './PrismRange';
import { Polygon2D } from './Polygon2D';
import { Coordinate } from './Coordinate';

export class ShowMeasuresRequest implements IShowMeasuresRequest {
    measures!: Measure[];

    constructor(data?: IShowMeasuresRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["measures"])) {
                this.measures = [] as any;
                for (let item of _data["measures"])
                    this.measures!.push(Measure.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ShowMeasuresRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ShowMeasuresRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.measures)) {
            data["measures"] = [];
            for (let item of this.measures)
                data["measures"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IShowMeasuresRequest {
    measures: Measure[];
}